import { render, staticRenderFns } from "./PopupOrderDeleteError.vue?vue&type=template&id=2852fcfa&scoped=true&"
import script from "./PopupOrderDeleteError.vue?vue&type=script&lang=js&"
export * from "./PopupOrderDeleteError.vue?vue&type=script&lang=js&"
import style0 from "./PopupOrderDeleteError.vue?vue&type=style&index=0&id=2852fcfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852fcfa",
  null
  
)

export default component.exports